import _ from 'lodash';
import React from 'react';

import {SidebarSection} from './components';
import identificationIcon from './assets/identification.svg';
import identificationSelectedIcon from './assets/identification-selected.svg';
import proofOfAddressIcon from './assets/proof-of-address.svg';
import proofOfAddressSelectedIcon from './assets/proof-of-address-selected.svg';
import visaIcon from './assets/visa.svg';
import visaSelectedIcon from './assets/visa-selected.svg';
import {KYC_SECTION_TYPES} from 'ducks/bookings';

import './styles.css';

const KYC_SECTION_ICONS = {
  [KYC_SECTION_TYPES.POID]: {
    icon: identificationIcon,
    selectedIcon: identificationSelectedIcon
  },
  [KYC_SECTION_TYPES.POA]: {
    icon: proofOfAddressIcon,
    selectedIcon: proofOfAddressSelectedIcon
  },
  [KYC_SECTION_TYPES.VISA]: {
    icon: visaIcon,
    selectedIcon: visaSelectedIcon
  }
};

const getClassName = ({isSelected}) => (isSelected ? 'selected' : null);

const getSectionIcon = ({isSelected, sectionType}) =>
  isSelected
    ? KYC_SECTION_ICONS[sectionType].selectedIcon
    : KYC_SECTION_ICONS[sectionType].icon;

const KycSidebar = ({selectedSectionType, sectionClickHandler}) => (
  <div className="KycSidebar">
    {_.map(_.keys(KYC_SECTION_TYPES), sectionType => {
      const isSelected = selectedSectionType === sectionType;
      return (
        <SidebarSection
          key={sectionType}
          icon={getSectionIcon({isSelected, sectionType})}
          className={getClassName({isSelected})}
          sectionType={sectionType}
          clickHandler={sectionClickHandler}
        />
      );
    })}
  </div>
);

export default KycSidebar;
